import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userContext } from "../App";
import { baseURL } from "../Config/settings";

import { toast } from "react-toastify";

import { useState } from "react";
import "./CSS/CheckoutForm.css"

const CheckoutForm = ({secret: clientSecret}) => {

    const {user, setUser} = useContext(userContext)
    let navigate = useNavigate()
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    // useEffect(() => {
    //   if(user === null) {
    //     toast.warn('You need to register before paying', {
    //       position: "top-right",
    //       autoClose: 2000,
    //       hideProgressBar: true,
    //       closeOnClick: true,
    //       pauseOnHover: false,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //     navigate('/auth')
    //   }
    // }, [navigate, user])

    const stripe = useStripe()
    const elements = useElements()

    const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });

    const result = stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: "https://eager-khorana-f1f606.netlify.app",
      },
      redirect: "if_required"
    })
    .then(data =>  {
      return fetch(`${baseURL}/auth/set-tier/`, {
        method: "POST",
        headers: {
            'Content-Type': "application/json"
        },
        body: JSON.stringify({
            "email": user.email
        })
      }
    )})
    .then(response => response.json())
    .then(data => setUser({...user, ...data}))



    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      // alert(result.error.message)
      toast.error(result.error.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      // console.log(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement></PaymentElement>
            <button className="stripe-payment-button" disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button>
        </form>
    )
}

export default CheckoutForm
